import {
    fetch
} from '@/plugin/axios/index.js'


/**
 * 添加
 * @param {Object} data
 */
export function saveData(data) {
    return fetch({
        url: '/sale/telemarketingTemplate/save',
        method: 'POST',
        data
    })
}


/**
 * @param {Object} data
 * 复制
 */
export function copyData(id) {
    return fetch({
        url: '/sale/telemarketingTemplate/copy',
        method: 'GET',
        params: {
            id
        },
    })
}

/**
* 列表
* @param {Object} data
*/
export function getPageList(data) {
    return fetch({
        url: '/sale/telemarketingTemplate/pageList',
        method: 'POST',
        data
    })
}


/**
 * @param {Object} data
 * 详情
 */
export function getDetail(id) {
    return fetch({
        url: '/sale/telemarketingTemplate/detail',
        method: 'GET',
        params: {
            id
        },
    })
}


/**
 * @param {Object} data
 * 删除
 */
export function deleteRow(data) {
    return fetch({
        url: '/sale/telemarketingTemplate/delete',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/salesManagement/whmb.js